<app-central-loader text="Carregando configurações..." [show]="buscando">
</app-central-loader>

<div id="main" class="col-xs-12">
  <app-breadcrumb currentPage="Configurações" routerCurrentPage="/configuracoes"></app-breadcrumb>

  <div id="records" class="row">
    <div *ngIf="!buscando" class="panel marginB0">
      <div class="panel-title">
        <h2>Configurações</h2>
      </div>
      <div class="checkbox-options">

        <h2>Notificações</h2>

        <div class="checkbox-item" *ngFor="let item of configuracao.configuracoes.tiposPush">
          <label [for]="item.$descTipoPush" class="label-checkbox">
            <input class="input-checkbox" type="checkbox" [(ngModel)]="item.habilitaPush" [name]="item.$descTipoPush" [id]="item.$descTipoPush" [disabled]="item.$isCanChange">
            <span>{{item.$descTipoPush}}</span>
            <small *ngIf="item.$isCanChange">   -   Opção não pode ser desabilitada</small>
          </label>
        </div>
      </div>

      <div class="btn-save">
        <button type="button" class="btn btn-full-orange" (click)="onClickSalvar()" data-dismiss="modal" [disabled]="salvando">
          <span *ngIf="!salvando">Salvar</span>
          <span *ngIf="salvando">Salvando...</span>
        </button>
      </div>
    </div>
  </div>

  <app-modal-message #modalMessage title="Atenção!" [hideClose]="true"></app-modal-message>